import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const Anlaggningar = lazy(() => import("@/pages/mina-sidor/Anlaggningar"));

export const Route = createFileRoute("/mina-sidor/anlaggningar")({
  component: () => <Anlaggningar />,
});
